import type {ProfileCfg} from './profileTypes'
import type {Role} from 'shared/forecast/roleTypes'

export type Permission =
  | '*'
  | 'question-edit'
  | 'question-edit-all'
  | 'question-view'
  | 'subquestion-edit'
  | 'settings'
  | 'new-workspace'
  | 'forecast'
  | 'result-view'

const rolePermission = {
  admin: ['*'] as Permission[],
  forecaster: ['question-view', 'subquestion-edit', 'forecast'],
  viewer: ['question-view'],
  reader: ['result-view']
} satisfies Record<Role, Permission[]>

export const profileHasPermission = (profile: Pick<ProfileCfg, 'roles'>, permission: Permission) =>
  profile.roles?.find(r => rolePermission[r]?.find(p => p == '*' || p == permission)) != null
